import { REQUIRED_MESSAGES } from '@srm/ui/lib/requiredMessage';
import React, { useEffect, useState } from 'react';
import { ProcessExecutionService } from '@services/actions/ProcessExecutionService';
import { IAbookTab } from '@models/Forms/IForms';
import { useForm } from 'react-hook-form';
import ModalContainer, { IModalContainerProps } from '@molecules/ModalContainer/ModalContainer';
import { useActionSubmit } from '@organisms/actions/useActionSubmit';
import { IAddressBookData } from '@models/addressbook/IAddressBookData';
import { IChangeControllerProps } from './IChangeControllerProps';
import { IChangeControllerFormData } from './IChangeControllerFormData';
import AbookpickerControl from '@controls/AbookpickerControl';

export const ChangeControllerModal: React.FC<IChangeControllerProps> = (props: IChangeControllerProps) => {
    const [controllerDisplayName, setControllerDisplayName] = useState<string>('');
    const activated = React.useRef(false);

    const serv = new ProcessExecutionService();

    const { errorText, setErrorText, isBusy, setIsBusy, isSubmitting, okClick, cancelClick } = useActionSubmit({
        completeHandler: props.completeHandler,
        initialBusy: true,
        submit: (form: IChangeControllerFormData) => serv.saveChangeController(props.processId, form?.controller),
    });

    const tabSettings = {
        name: 'Сотрудники',
        mode: 'list',
        child: 'Person',
        columns: [
            { key: 'fullName', name: 'Наименование', width: '', allowSort: true },
            { key: 'email', name: 'Email', width: '' },
        ],
        cache: JSON.stringify({
            name: 'Сотрудники',
            mode: 'list',
            child: 'Person',
        }),
    } as IAbookTab;

    const formState = useForm<IChangeControllerFormData>({
        mode: 'onBlur', // "onChange"
    });

    useEffect(() => {
        // Закрытое окно ответ подготовки не применяет.
        let ignore = false;
        setIsBusy(true);
        activated.current = true;

        serv.getChangeControllerModel(props.processId)
            .then((res) => {
                if (ignore) return;
                setControllerDisplayName(res.data.controllerFullName);
                formState.reset({ controller: res.data.controllerKey });
            })
            .catch(() => {
                if (!ignore) setErrorText('Ошибка получения данных от сервера.');
            })
            .finally(() => {
                if (!ignore) setIsBusy(false);
            });
        return () => {
            ignore = true;
            activated.current = false;
        };
    }, []);

    const modalContainerProps: IModalContainerProps = {
        header: props.title,
        size: props.modalSize,
        showOkButton: true,
        showCancelButton: true,
        okButtonText: props.okButtonText,
        cancelButtonText: props.cancelButtonText,
        loading: isBusy,
        closeDisabled: isSubmitting,
        onCancel: cancelClick,
        errorText: errorText,
        formMethods: formState,
        onSubmit: okClick,
        okButtonDisabled: false,
    };

    return (
        <ModalContainer {...modalContainerProps}>
            <AbookpickerControl
                label="Контролирующий по маршруту"
                placeholder="Выберите пользователя из адресной книги"
                isMultiple={false}
                title="Контролирующий по маршруту"
                displayValue={controllerDisplayName}
                formValues={'{}'}
                name="controller"
                tabsSettings={[tabSettings]}
                required
                rules={{ required: REQUIRED_MESSAGES.select }}
                showChips={false}
                control={formState.control}
                onSetValues={(value: IAddressBookData[]) => {
                    setControllerDisplayName(value[0].fullName);
                }}
            />
        </ModalContainer>
    );
};
